import { NgModule } from '@angular/core';
import { FiBrowserCheckService } from './browser-check.service';
import { FiBrowserCheckNotificationComponent } from './browser-check-notification.component';
import { FiAppTextSharedModule } from '../../../shared/app-text';

@NgModule({
    imports: [FiAppTextSharedModule],
    declarations: [FiBrowserCheckNotificationComponent],
    exports: [FiBrowserCheckNotificationComponent],
    providers: [FiBrowserCheckService],
})
export class FiBrowserCheckModule {}
